import { ReactNode, RefObject, useRef } from 'react'
import { TutorialRefs } from './tutorial-context.def'
import { TutorialContext } from './use-tutorial'

export const TutorialProvider = ({ children }: { children: ReactNode }) => {
  const refsRef = useRef<TutorialRefs>({
    createIdea: null,
    tableColumn: null,
    summaryData: null,
  })

  const setRef = (
    key: keyof TutorialRefs,
    ref: RefObject<HTMLElement | null> | null
  ) => {
    refsRef.current[key] = ref
  }

  return (
    <TutorialContext.Provider value={{ refs: refsRef.current, setRef }}>
      {children}
    </TutorialContext.Provider>
  )
}
